import dayjs from 'dayjs';

export const timestampInSeconds = (seconds: number, mls = 1e3) => seconds * mls;

const LONG_DISPLAY_FORMAT = 'MMMM DD, YYYY H:mm';

export const formatAsLocalizedLong = (date: number | string) => {
    if (typeof date === 'string') {
        return dayjs(date).format(LONG_DISPLAY_FORMAT);
    }

    return dayjs.unix(date as number).format(LONG_DISPLAY_FORMAT);
};

export const pluralize = (count:number, noun:string, suffix = 's') => (
    `${noun}${count !== 1 ? suffix : ''}`
);
